import {
  FETCH_RESERVATION_LOADING,
  FETCH_RESERVATION_SUCCESS,
  FETCH_RESERVATION_ERROR,
  DELETE_OPERATION_ERROR,
  DELETE_OPERATION_SUCCESS,
  DELETE_OPERATION_LOADING,
  FETCH_OPERATION_LOADING,
  FETCH_OPERATION_SUCCESS,
  FETCH_OPERATION_ERROR,
  DELETE_RESERVATION_ERROR,
  DELETE_RESERVATION_LOADING,
  DELETE_RESERVATION_SUCCESS,
  FETCH_DEPARTMENT_OPERATIONS_ERROR,
  FETCH_DEPARTMENT_OPERATIONS_SUCCESS,
  FETCH_DEPARTMENT_OPERATIONS_LOADING,
  FETCH_RESERVATION_FLOOR_SUCCESS,
  FETCH_RESERVATION_FLOOR_LOADING
} from '../Types/operationTypes';

const initState = {
  data: [],
  operationsByDepartment: {},
  error: null,
  success: null,
  loading: true,
  deleteLoading: false
};

const operationReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_RESERVATION_LOADING:
    case FETCH_DEPARTMENT_OPERATIONS_LOADING:
    case FETCH_RESERVATION_FLOOR_LOADING:
      return {
        ...state,
        loading: true,
        data: []
      };

    case FETCH_RESERVATION_SUCCESS:
    case FETCH_RESERVATION_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    case FETCH_DEPARTMENT_OPERATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        operationsByDepartment: action.payload
      };

    case FETCH_RESERVATION_ERROR:
    case FETCH_DEPARTMENT_OPERATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
        success: null
      };

    case DELETE_OPERATION_LOADING:
      return {
        ...state,
        deleteLoading: true
      };

    case DELETE_OPERATION_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        data: state.data.filter(item => item._id !== action.payload)
      };

    case DELETE_OPERATION_ERROR:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload
      };

    case FETCH_OPERATION_LOADING:
      return {
        ...state,
        loading: true,
        data: []
      };

    case FETCH_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };

    case FETCH_OPERATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
        success: null
      };

    default:
      return { ...state };
  }
};

export default operationReducer;
